import { DocumentSnapshot } from '../FirestoreTypes';
import { BaseDocument } from './BaseDocument';
import { UserMedicationSchema } from '../schemas/Patient';

export class UserMedicationDocument extends BaseDocument<UserMedicationSchema> {
    constructor(snapshot: DocumentSnapshot<UserMedicationSchema>) {
        super(snapshot, 'User Medication');
    }
}
